import React from 'react';
import { IconProps } from 'src/assets/icons/types';

const InfoIconOutlined: React.FC<IconProps> = props => {
  const { className, size = 16, fillColor = '#969696', height, width } = props;
  return (
    <svg
      className={className}
      width={width ? width : size}
      height={height ? height : size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_13192_128696"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width={width ? width : size}
        height={height ? height : size}
      >
        <rect width={width ? width : size} height={height ? height : size} fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_13192_128696)">
        <path
          d="M8.00016 11.332C8.18905 11.332 8.3475 11.268 8.4755 11.14C8.60305 11.0125 8.66683 10.8543 8.66683 10.6654V7.98203C8.66683 7.79314 8.60305 7.63759 8.4755 7.51536C8.3475 7.39314 8.18905 7.33203 8.00016 7.33203C7.81127 7.33203 7.65305 7.39581 7.5255 7.52336C7.3975 7.65136 7.3335 7.80981 7.3335 7.9987V10.682C7.3335 10.8709 7.3975 11.0265 7.5255 11.1487C7.65305 11.2709 7.81127 11.332 8.00016 11.332ZM8.00016 5.9987C8.18905 5.9987 8.3475 5.9347 8.4755 5.8067C8.60305 5.67914 8.66683 5.52092 8.66683 5.33203C8.66683 5.14314 8.60305 4.9847 8.4755 4.8567C8.3475 4.72914 8.18905 4.66536 8.00016 4.66536C7.81127 4.66536 7.65305 4.72914 7.5255 4.8567C7.3975 4.9847 7.3335 5.14314 7.3335 5.33203C7.3335 5.52092 7.3975 5.67914 7.5255 5.8067C7.65305 5.9347 7.81127 5.9987 8.00016 5.9987ZM8.00016 14.6654C7.07794 14.6654 6.21127 14.4903 5.40016 14.14C4.58905 13.7903 3.8835 13.3154 3.2835 12.7154C2.6835 12.1154 2.20861 11.4098 1.85883 10.5987C1.50861 9.78759 1.3335 8.92092 1.3335 7.9987C1.3335 7.07648 1.50861 6.20981 1.85883 5.3987C2.20861 4.58759 2.6835 3.88203 3.2835 3.28203C3.8835 2.68203 4.58905 2.20692 5.40016 1.8567C6.21127 1.50692 7.07794 1.33203 8.00016 1.33203C8.92239 1.33203 9.78905 1.50692 10.6002 1.8567C11.4113 2.20692 12.1168 2.68203 12.7168 3.28203C13.3168 3.88203 13.7917 4.58759 14.1415 5.3987C14.4917 6.20981 14.6668 7.07648 14.6668 7.9987C14.6668 8.92092 14.4917 9.78759 14.1415 10.5987C13.7917 11.4098 13.3168 12.1154 12.7168 12.7154C12.1168 13.3154 11.4113 13.7903 10.6002 14.14C9.78905 14.4903 8.92239 14.6654 8.00016 14.6654ZM8.00016 13.332C9.47794 13.332 10.7364 12.8127 11.7755 11.774C12.8142 10.7349 13.3335 9.47648 13.3335 7.9987C13.3335 6.52092 12.8142 5.26248 11.7755 4.22336C10.7364 3.1847 9.47794 2.66536 8.00016 2.66536C6.52239 2.66536 5.26416 3.1847 4.2255 4.22336C3.18638 5.26248 2.66683 6.52092 2.66683 7.9987C2.66683 9.47648 3.18638 10.7349 4.2255 11.774C5.26416 12.8127 6.52239 13.332 8.00016 13.332Z"
          fill={fillColor}
        />
      </g>
    </svg>
  );
};

export default InfoIconOutlined;
